module.exports = __webpack_public_path__ + "static/media/add.f1ced6c0.svg";